export default () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <ellipse
      cx='10'
      cy='5'
      rx='5.5'
      ry='2.5'
      stroke='#5A607F'
      strokeWidth='1.5'
    />
    <path
      d='M4.5 7V9.5C4.5 10.3284 7.46243 11 10 11C12.5376 11 15.5 10.3284 15.5 9.5V7'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M4.5 10.5V13C4.5 13.8284 7.46243 14.5 10 14.5C12.5376 14.5 15.5 13.8284 15.5 13V10.5'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M4.5 14V15.25C4.5 16.2165 7.17496 17 10 17C12.825 17 15.5 16.2165 15.5 15.25V14'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);
